import { withSvgIcon } from './withSvgIcon';

export const Doc = withSvgIcon(
  <>
    <path
      d="M19 9H16.22C15.081 9 14.5115 9 14.0781 8.77483C13.7128 8.58508 13.4149 8.28724 13.2252 7.92195C13 7.48847 13 6.91898 13 5.78V3M19 9V17.78C19 18.919 19 19.4885 18.7748 19.9219C18.5851 20.2872 18.2872 20.5851 17.9219 20.7748C17.4885 21 16.919 21 15.78 21H8.22C7.08102 21 6.51153 21 6.07805 20.7748C5.71276 20.5851 5.41492 20.2872 5.22517 19.9219C5 19.4885 5 18.919 5 17.78V6.22C5 5.08102 5 4.51153 5.22517 4.07805C5.41492 3.71276 5.71276 3.41492 6.07805 3.22517C6.51153 3 7.08102 3 8.22 3H13M19 9L13 3"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9 13H15"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M9 17H13"
      stroke="currentColor"
      strokeWidth="currentWidth"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
